'use strict';

/* Controllers */

app.controller('RegisterController', ['$scope', '$rootScope', '$location', 'Auth', 'User', 'Popup', 'Helper', 'Preloader', 
    function ($scope, $rootScope, $location, Auth, User, Popup, Helper, Preloader) {

        Auth.redirectIfLoggedIn();

        // init scope vars
        $scope.email     = '';
        $scope.username  = '';
        $scope.password  = '';
        $scope.password2 = '';
        $scope.avatar    = '';

        $scope.birthday = {
            day   : '',
            month : '',
            year  : ''
        };

        $scope.email_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        /**
         * called when user submits registration form
         */
        $scope.registerUser = function() {

            Preloader.open();

            // prepare user object
            var user = {
                username: $scope.username,
                email:    $scope.email,
                password: $scope.password,
                password_confirmation: $scope.password2,
                sex:      $scope.gender || '',
                dob:      $scope.getFormatedBirthday(),
                ava:      $scope.avatar
            };

            // register user via API
            Auth.register(user, function(resp, status) {
                if( status == 200 ) {
                    Auth.setCredentials(resp.data.user);

                    // get credit
                    User.getCredit(function(){

                        // this will go to intended or landing page
                        Auth.redirectIfLoggedIn();
                    });
                }
                else if( status == 500 ){
                    Popup.error('Something went wrong :(');
                }
                else if(resp.data.error == true) {
                    // get errors
                    var errors = [];

                    if( resp.data.message instanceof Object ){
                        angular.forEach(resp.data.message, function(value, key) {

                            switch( value[0] ){
                                case 'The ava field is required.':
                                    errors.push('We need your pic so your friend knows who sent this fabulous gift.');
                                    break;

                                default: errors.push(value[0]);
                            }
                        });
                    }
                    else{
                        errors.push(resp.data.message);
                    }

                    Popup.error(errors);
                }

                Preloader.close();
            });
        }


        /**
         * signup with facebook
         */
        $scope.facebookSignup = function(){

            FB.login(function(response) {
                
                Auth.fbConnect(response.authResponse.accessToken, function(resp, status){
                    if( status == 200 ){
                        // success
                        Auth.setCredentials(resp.data.user);

                        // get credit
                        User.getCredit(function(){
                            
                            // this will go to intended or landing page
                            Auth.redirectIfLoggedIn();
                        });
                    }
                    else if( status == 500 ){
                        $scope.error = Helper.getProperty(resp, 'data.message');
                    }
                });

            }, {scope: 'email'});
        }



        /**
         * previrew avatar after selection
         * 
         * @param  event
         * @param  files
         */
        $scope.previewAvatar = function(event, files){
            var input = event.target;

            if (input.files && input.files[0]) {
                var reader = new FileReader();
                
                reader.onload = function (e) {
                    $scope.$apply(function() {
                        $('.file-upload img').attr('src', e.target.result);
                    });
                }
                
                reader.readAsDataURL(input.files[0]);
            }
        }


        /**
         * show validatyion errors in popup on click
         */
        $scope.showValidationErrors = function(){
            var errors = [];

            // angular scope vars are undefined until they are valid
            // so we have to do a stupid workaround
            var avatar    = $('input[type=file]').val();
            var email     = $('input[name=email]').val();
            var username  = $('input[name=username]').val();
            var password  = $('input[name=password]').val();
            var password2 = $('input[name=password2]').val();


            // check email
            if( email == '' )                   errors.push('Email field is required.');
            else
                if( $scope.registerForm.email.$invalid ) errors.push('You have entered an invalid email address.');

            // check username
            if( username.length < 4 )           errors.push('Username must have at least 4 characters.');
            else 
                if( username.length > 18 )      errors.push('Username cannot be longer than 18 characters.');
                else if( $scope.registerForm.username.$invalid ) errors.push('You have entered an invalid username.');

            // check password
            if( password.length < 6 )           errors.push('Password must have at least 6 characters.');
            else
                if( password.length > 18 )      errors.push('Password cannot be longer than 18 characters.');

            // check password with confirm password
            if( password != password2 )         errors.push("Password and confirm password fields dosn't match.");

            if( errors.length > 0 ){
                Popup.error(errors);
            }
        }


        /**
         * get values for birthday dropdown
         */
        $scope.selects = {
            days: function() {
                // Get number of days based on month + year 
                // (January = 31, February = 28, April = 30, February 2000 = 29) or 31 if no month selected yet
                var nbDays = new Date($scope.birthday.year, $scope.birthday.month, 0).getDate() || 31;

                var daysList = [];
                for (var i = 1; i <= nbDays; i++) {
                    var iS = i.toString();
                    daysList.push((iS.length < 2) ? '0' + iS : iS); // Adds a leading 0 if single digit
                }
                return daysList;
            },
            months: function() {
                var monthList = [];
                for (var i = 1; i <= 12; i++) {
                    var iS = i.toString();
                    monthList.push((iS.length < 2) ? '0' + iS : iS); // Adds a leading 0 if single digit
                }
                return monthList;
            },
            years: function() {
                var yearsList = [];
                var endYear = new Date().getFullYear()-18;
                var startYear = new Date().getFullYear()-100;

                for (var i = endYear; i >= startYear; i--) {
                    yearsList.push(i.toString());
                }
                return yearsList;
            }
        }


        /**
         * get formated birthday
         */
        $scope.getFormatedBirthday = function(){

            if( $scope.birthday.year != '' && $scope.birthday.month != '' && $scope.birthday.day != '' ){
                return $scope.birthday.year+'-'+$scope.birthday.month+'-'+$scope.birthday.day;
            }

            return '';
        }

    }]);